<template>
  <!-- :action="$http.uploadUrl" -->
  <!-- :on-success="handleSuccess" -->
  <div>
    <el-upload
      class="avatar-uploader2"
      accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG, .PNG, .GIF"
      action=""
      :show-file-list="false"
      :before-upload="beforeUpload"
      :http-request="uploadData"
    >
      <img v-if="imageUrl" :src="imageUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon" />
      <div slot="tip" class="el-upload__tip btn-tip">仅支持 jpg/png格式图片</div>
    </el-upload>
  </div>

</template>
<script>
import { uploadFile } from '@api/api_common'
export default {
  props: {
    // 上传的文件
    fileList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      // imageUrl: ''
    }
  },
  computed: {
    list: {
      get() {
        return this.fileList
      },
      set(val) {
        this.$emit('update:fileList', val)
      }
    },

    imageUrl() {
      if (this.fileList[0] && this.fileList[0].url) {
        return this.fileList[0].url
      } else {
        return ''
      }
    }
  },

  methods: {
    uploadData(data) {
      const formData = new FormData()
      formData.append('file', data.file)
      uploadFile(formData).then(res => {
        const response = { name: res.fileOriginalName, url: res.rootPath, id: res.id, uid: data.file.uid }
        this.list = [response]
        this.$message.success('上传成功')
      })
    },
    // 图片上传前检测
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      const isJPEG = file.type === 'image/jpeg'
      const isJPG = file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      if (!isJPG && !isPNG && !isJPEG) {
        this.$message.closeAll()
        this.$message.error('应上传 JPG/PNG 格式!')
      }
      return isLt2M || isJPG || isJPEG || isPNG
    }
    // 图片上传成功后传值
    // handleSuccess(res, file) {
    //   this.$emit('update:key', res.files.file)
    //   this.imageUrl = URL.createObjectURL(file.raw)
    // }
  }
}
</script>

<style lang="scss">
  .avatar-uploader2{
    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar {
      width: 100px;
      height: 100px;
      display: block;
    }
    .el-upload__tip{
      display: block;
      margin-left: 0;
      line-height: initial;
      color: #898884;
      margin-top: -4px;
    }
    .el-upload:hover {
      border-color: #FDC100;
      .el-icon-plus:before{color: #FDC100;}
    }
    .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  }

  // .avatar-uploader2{
  //   line-height: 1;
  // }

</style>

